import { CardApplicationApi } from '@/src/experiences/card-application/stores/api'
import { useIsUserSignedIn } from '@/src/common/hooks/useIsUserSignedIn'

export function useNewestApplication() {
  // todo: extract this into a `useLoggedInQuery` hook similar to the grpahql version in src/common/gql/MesaGql/index.ts
  const { isSignedInWithPhoneNumber } = useIsUserSignedIn()

  return CardApplicationApi.endpoints['GET /card/onboarding/applications'].useQuery(null, {
    skip: !isSignedInWithPhoneNumber,
    selectFromResult(query) {
      return query.data
        ? ({
            ...query,
            data: {
              ...query.data,
              newestApplication: query.data.applications.length
                ? query.data.applications.reduce((newest, current) =>
                    current.updatedAt.localeCompare(newest.updatedAt) ? current : newest,
                  )
                : undefined,
            },
          } as const)
        : ({ ...query, data: undefined } as const)
    },
  })
}
